export class EventChartPosition {
  // Percentage values that can be assigned to a datazoom
  start: number;
  end: number;

  constructor(init: Readonly<EventChartPosition>) {
    Object.assign(this, init);
  }
}
